import { EnvironmentProviders, makeEnvironmentProviders, inject, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs'; // Needed for loader

// Custom Loader to avoid dependency issues with library version
export class CustomTranslateLoader implements TranslateLoader {
    constructor(private http: HttpClient, private prefix: string = './assets/i18n/', private suffix: string = '.json') { }

    public getTranslation(lang: string): Observable<any> {
        return this.http.get(`${this.prefix}${lang}${this.suffix}`);
    }
}

// Factory for custom loader
export function HttpLoaderFactory(http: HttpClient) {
    return new CustomTranslateLoader(http);
}

export function provideSharedI18n(): EnvironmentProviders {
    return makeEnvironmentProviders([
        importProvidersFrom(TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'es'
        })),
        // Auto-detect language on app startup
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                const translate = inject(TranslateService);
                return () => {
                    translate.setDefaultLang('es');
                    const browserLang = translate.getBrowserLang();
                    if (browserLang) {
                        translate.use(browserLang);
                    } else {
                        translate.use('es');
                    }
                    return new Promise<void>(resolve => resolve());
                };
            },
            multi: true
        }
    ]);
}
